export { default as AssetClassBreakdownBar } from './component';
